<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { FacetList } from '@/api/games/facet';


export default {
    name: "facet-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: FacetList,
        }
    }
}
</script>